<template>
  <div :class="modalTheme" style="padding-bottom: 0px">
    <!-- <div :class="modalTheme">
      <div :class="userStore.borderClass">
      borderClass  <h6>modalTheme: {{ modalTheme }}</h6>
      </div>
    </div> -->
    <!-- <h3>SEARCH LOGIN SECURITY</h3> -->

    <div class="group-search-login-row">
      <div class="d-flex align-items-baseline">
        <span class="group-label" :variant="headerBgVariant">
          <b-badge :class="modalTheme">
            <span style="font-size: small; font-weight: bolder; padding-left: 5px; padding-right: 15px">Group</span>
            <b-form-select
              :class="modalTheme"
              size="sm"
              name="securityGroupsSelect"
              value-field="id"
              text-field="name"
              :options="userStore.securityGroups"
              v-model="userStore.currentSecurityGroup"
              :variant="headerBgVariant"
              style="width: auto"
              @change="setSecurityGroup"
            />
            <h3 v-if="AreIdsShown" class="language-json">
              <code style="background-color: rgb(10, 115, 190); color: cyan">{{ userStore.currentSecurityGroup }}</code>

              <code style="background-color: rgb(10, 115, 190); color: cyan">
                {{ userStore.securityGroups.find((group) => group.id === userStore.currentSecurityGroup)?.name || "Unknown Group" }}
              </code>
            </h3>
          </b-badge>
          <div v-if="devToggle" style="background: black; color: cyan">themes {{ themes.current() }}</div>
          <h6 v-if="devToggle" :style="{ color: userStore.hasFullPatientChart ? 'green' : 'red' }">CURRENT : {{ userStore.currentSecurityGroup }}</h6>
          <h6
            v-if="devToggle"
            :style="{
              'background-color': userStore.hasFullPatientChart ? '#6a8560AA' : '#6e5858AA',
              color: 'cyan',
              'padding-left': '20px',
            }"
          >
            FULL Chart: {{ userStore.hasFullPatientChart }}
          </h6>
        </span>
      </div>

      <DataCallTestButton v-if="devToggle" />

      <div style="width: 250px" id="patient-search-input-group" class="input-group">
        <!-- <input v-model.trim="userSearchTerm" type="text" placeholder="TEST" /> -->
        <!-- {{ userSearchTerm }} -->

        <b-form-input
          class="py-0 border border-right-0"
          :class="modalTheme"
          @keyup.enter="patientSearch"
          v-model="userSearchTerm"
          placeholder="Patient Search"
          @focus="showPopper = true"
          @blur="showPopper = false"
        ></b-form-input>

        <span class="input-group-append">
          <Popper arrow :show="showPopper" @focus="showPopper = true" @blur="showPopper = false" :class="modalTheme">
            <b-button :class="modalTheme" @click="patientSearch" size="sm" class="my-0 mr-0 my-sm-0" type>
              <font-awesome-icon :icon="['fas', 'magnifying-glass']" size="1x" />
            </b-button>
            <template #content>
              <!-- <div>This is the Popper content</div> -->
              <!-- If your content is more complex, you can use the content slot: -->
              <div class="search-results-wrapper" style="width: 900px">
                <!-- searchResults {{searchResults}} -->
                <div class="search-results">
                  <div
                    v-for="result in searchResults"
                    :key="result.personID"
                    @click="selectPatient(result.personID)"
                    :title="formatSearchResultsTitle(result)"
                    href="#"
                    class="search-results-table__record"
                  >
                    <div class="search-results-table__cell">
                      <span class="label">{{ result.lastName }}, {{ result.firstName }}</span>
                    </div>
                    <div class="search-results-table__cell">
                      <span class="label">DOB:</span>
                      {{ result.dateOfBirth }}
                    </div>
                    <div class="search-results-table__cell">
                      <span class="label">Insurance:</span>
                      {{ result.insuranceCarrier }}
                    </div>
                    <div class="search-results-table__cell">
                      <span class="label">Provider:</span>
                      {{ result.providerName }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Popper>
        </span>
      </div>

      <div class="login-info" style="background: transparent; padding: 00px">
        <!-- <font-awesome-icon icon="fa-solid fa-id-card" />
      <font-awesome-icon icon="fa-solid fa-user" />
      <font-awesome-icon icon="fa-solid fa-image-portrait" /> -->

        <b-row style="background: transparent; margin-right: 6px">
          <!-- <OrangeThemeToggle v-if="themes.current() === 'generic.dark'" /> -->

          <b-col v-if="devDesign">
            <ThemeToggle />
            <!-- <h6>Chat</h6> -->
            <b-button v-if="AreIdsShown" :class="modalTheme" size="sm" class="my-0 mr-0 my-sm-0" type v-b-modal.modalChat>
              <font-awesome-icon :icon="['far', 'comment-dots']" size="lg" />
            </b-button>
            <b-modal id="modalChat" title="Chat" body-class="p-0" size="md" hide-footer :content-class="modalTheme" :header-class="modalTheme">
              <div class="d-flex justify-content-center align-items-center" style="height: 100%; width: 100%">
                <!-- <h4 class="text-center">Hello from our Chat system!</h4> -->
                <Chat />
              </div>
            </b-modal>
          </b-col>

          <!-- <b-col style="background: red"></b-col> -->
          <!-- &^                                               ADD THIS  -->
          <b-col v-if="workListStore.allMyAlertsNotViewedQty > 0" style="padding: 0%; padding-top: 6px; padding-right: 12px">
            <span class="fa-stack fa-1x" style="cursor: pointer" @click="router.push('/announcements')">
              <font-awesome-icon class="fa-stack-1x fa-inverse" :icon="['fas', 'bell']" size="3x" style="font-size: 18pt; color: #6f9f5ed7" />
              <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-8 down-3" style="font-weight: 900">{{ workListStore.allMyAlertsNotViewedQty }}</span>
            </span>
          </b-col>
          <b-col style="background: transparent; padding: 0px; padding-right: 3px; border-radius: 6px">
            <UserProfile :user="userStore._user" :variant="headerBgVariant" />
          </b-col>
          <!-- <b-col style="padding-right: 3px">
            <LogOutButton />
          </b-col> -->
        </b-row>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, reactive, computed, watch, onMounted, onBeforeMount } from "vue";

import UserProfile from "@/modules/User/UserProfile.vue";
import { useStoreUser } from "@/stores/userStore";
import { usePatientStore } from "@/stores/patientStore";

import DataCallTestButton from "@/views/DataCallTestButton.vue";

import LogInButton from "@/modules/User/LogInButton.vue";
import LogOutButton from "@/modules/User/LogOutButton.vue";

import { searchForPatient } from "@/api/patientApi";
import { getPatientTasks } from "@/api/discreteDataApi";

// & ROUTER
import { useRouter, useRoute } from "vue-router";
const router = useRouter(); // router.push()
const route = useRoute();

import Popper from "vue3-popper";
import { toast } from "vue3-toastify";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";

// * STORE  USER
const userStore = useStoreUser();
const userLocal = userStore._user;
const secGroups = userStore.securityGroups;
const currentSecurityGroup = userStore.currentSecurityGroup;
const userSearchTerm = ref("");

// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();
// * STORE  PATIENT
const patientStore = usePatientStore();

import OrangeThemeToggle from "@/components/OrangeThemeToggle.vue";

import ThemeToggle from "@/components/ThemeToggle.vue";

import Chat from "./Chat.vue";

const selectedTheme = computed({
  get: () => userStore.bModalTheme,
  set: (val) => {
    userStore.bModalTheme = val;
  },
});

const modalTheme = computed(() => selectedTheme.value);
// ^ Parameters
// const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const devToggle = ref(false);
const devDesign = ref(false);

const headerBgVariant = reactive("dark-greenSummary"); //DaVinci  inspinia primary-green
const variant = "danger";
let searchTerm = reactive(userSearchTerm);

// * ROUTE.NAME
const currentRouteName = computed(() => route.name); // ROUTE.NAME

const personsTasks = ref([]);
let searchResults = ref([]);
const showSearchResults = ref(null);

//! showPOPPER
const showPopper = ref(null);
const hidePopper = () => {
  showPopper.value = false;
  showSearchResults.value = false;
  searchTerm.value = "";
  nextTick(() => {
    showPopper.value = null;
    showSearchResults.value = null;
  });
};

// * a computed ref
const showResultsList = computed(() => {
  return searchResults && searchTerm;
});

// * EMITTER
const emit = defineEmits(["rteName"]);

import themes from "devextreme/ui/themes";
// themes.current("generic.contrast.compact");
// themes.current("generic.light.compact");
// themes.current("generic.dark.compact");
// themes.current("generic.general-light-blue-scheme");
// themes.current("generic.general-dark-blue-scheme");
// themes.current("generic.light");
// themes.current("generic.contrast.compact");

// const securityGroup = computed({
//       get()
// 			{
// 				userStore.setPatientChartBool()

// 				return this.currentSecurityGroup
// 			},
//       set(id)
// 			{
// 				console.log('  ........................... SET securityGroup id : ', userStore.currentSecurityGroup)

// 				userStore.changeSecurityGroupToStore(userStore.currentSecurityGroup).then((resp) =>
// 				{
// 					console.log(' resp ')
// 					console.dir(resp)

// 					if (resp.ok) {
// 						// // console.log('  									***************								RUN mutation from user store   this.serPatientChartbool')
// 						// // console.log('ON : this.setPatCHART bool >  ')
// 						userStore.setPatientChartBool()

//             if (route.name === 'Measures') {
// 						// if (this.$router.currentRoute.name === 'Measures') {
// 							// // console.log(' Measures reached !!!    false ')
// 							// this.$router.go(this.$router.currentRoute)
// 							// this.$emit('rteName', false)
//               emit('rteName', false)
// 						}
// 						else if (router.name === 'Summary'){
//             // if (this.$router.currentRoute.name === 'Summary') {
// 							// // console.log(' 		SUMMARY  reached !!!    true ')
// 							// this.$router.push({ path: '/Summary' })
// 							// this.$emit('rteName', this.$router.currentRoute.name)
// 							// this.$emit('rteName', true)
//               emit('rteName', true)
// 							// this.$root.$emit('rteName', true)
// 							// this.$emit('savePatientToList', patient.personID)
// 							// this.$root.emit('openPopup')

// 						}
// 						else {
// 							// this.$router.go({ path: '/LandingPage' })
// 							// // console.log(' rteName null !!!!!!!!  ')
// 							// this.$emit('rteName', null)
//               emit('rteName', null)
// 						}
// 					}
// 				})
// 			},
// });

function openAlert() {
  alert("Opening Popper!");
}
function closeAlert() {
  alert("Closing Popper!");
}

// * FUNCTIONS
async function patientSearch() {
  // console.clear();
  // console.log("PATIENT SERACH");
  // console.log("PATIENT SERACH  userSearchTerm");
  // console.log(userSearchTerm.value);

  if (!userSearchTerm.value || userSearchTerm.value.length < 3) {
    // console.log(" useL: ", userSearchTerm.value.length);
    return;
  }
  // showSearchResults = true;

  const result = await searchForPatient(userSearchTerm.value);

  // userSearchTerm.value = ''
  if (result.ok && result.payload) {
    //todo Add bootstrap confirm modal on
    // ! If localStorage

    // console.log("  RESULT OK   new Router PUSH  TEST ");
    // literal string path
    // router.push("/LandingPage");
    router.push("/emr");

    if (result.payload.length === 0) {
      // toastrSuccess("No results");
      alert(" NO RESULTS");
      return;
    }
    if (result.payload.length === 1) {
      const patient = result.payload[0];
      // console.log(" PATIENT> <<<<<<<<<<<<  IS   ONE   >>>>>>>>>>>>>>>>>>>>>>>>");

      // someTest();
      // someTest1();

      // console.dir(patient);
      putPatientIntoContext(patient);

      return;
    }

    // console.log("     CLEARING   SERACH TERM");
    // searchTerm.value = ""
    // userSearchTerm.value = "";
    // console.log("result.payload");
    // console.log(result.payload);

    searchResults = result.payload;
    // console.log("searchResults");
    // console.log(searchResults);

    showSearchResults.value = true;
    showPopper.value = true;

    // console.log("showSearchResults");
    // console.log(showSearchResults.value);

    // userSearchTerm.value = "";
  } else {
    showSearchResults.value = false;
    // toastrError(
    //   "There was a problem getting patient search back.  Please contact technical support if problem persists"
    // );
    alert("There was a problem getting patient search back.  Please contact technical support if problem persists");
  }
}

function someTest() {
  alert("some test");
}
const someTest1 = () => {
  alert(" Lamba TEST");
};
function selectPatient(personID) {
  // console.log(" ON  selectPatient  personID : ", personID);
  // console.log("     showPOPPER  OFF");

  showPopper.value = false;

  const index = searchResults.findIndex((patient) => patient.personID === personID);
  const patient = searchResults[index];
  putPatientIntoContext(patient);

  // * LOOP
  // console.log(" select patient LOOP  if FINISHTAKS");
  // console.log(finishTasks);

  // if (!finishTasks) {
  //   const index = searchResults.findIndex((patient) => patient.personID === personID);
  //   const patient = searchResults[index];
  //   putPatientIntoContext(patient);
  // }
}
function formatSearchResultsTitle(searchPatient) {
  return `Patient ID: ${searchPatient.patientID}\nDOB: ${searchPatient.dateOfBirth}\nMemberId: ${searchPatient.memberID}\nInsurance: ${searchPatient.insuranceCarrier}`;
}
async function putPatientIntoContext(patient) {
  // console.clear();
  // console.log("*** putPatientIntoContext ***");
  // console.log("  Patient  ");

  // console.log(patient);

  // console.log("*** resetSearch ***");
  // console.log(this)
  resetSearch();

  // console.log("");
  // console.log("   NEW  .setCurrentPatient(patient); from NEW PATIENT STORE  ");
  // console.log("");
  // console.log("");
  // console.log("");

  // console.log(" NEW        PATIENT      STORE           >>>>>>>>>>>>>>>           PATIENT >>  STR  MUTATION    *** setCurrentPatient ***");
  patientStore.setCurrentPatient(patient);

  // console.log("  ADD the currentPatient to   patSt patArray  if not currently");

  // console.log("*** ***");
  // console.log("*** STOP   add  disctDATA API  ***");

  const localPersonId = patient.personID;
  // console.log(" BIND localPersonId:  patient.personID   = ", localPersonId);

  // ! NEW
  // console.log(" getPatientTasks ");
  //? NEW GetPatient Tasks

  const response = await getPatientTasks(localPersonId);

  // console.log("await getPatientTasks");
  // console.log("response");
  // console.log(response);

  if (response.ok) {
    // console.log("										>>> SETTING curr Patient Tasks ..........................");
    patientStore.setCurrentPatientTasks(response.payload);

    // console.log(" TASKS filled");
    // console.log(" 		PUSH ROUTE to Encounter  with   ID   patient.personID");
    // console.log("patient.personID");
    // console.log(patient.personID);

    // & ROUTE PUSH  assessment
    router.push({
      name: "assessment",
      params: { id: patient.personID },
    });

    // console.log(" 		check  patientArray for Patient   IIF NOT  add to list ");

    // if (!patientStore.patientArray.includes(patientStore.currentPatient.personID)) {
    //   patientStore.addPatientToArray(patientStore.currentPatient);
    //   // console.clear();
    // }
    // // // // // console.log(' PUSH 2 ROUTER   encounter  params:  id: patient.personID '	)
    // this.$router.push({
    // 	name: "encounter",
    // 	params: { id: patient.personID },
    // });

    // //? add to localStorage
    // // // // // console.log(					' > CurrentPatient : SET localST.currentPatientId : patientStore.currentPatientId '				)
    // if (this.$store.state["patient"].currentPatient) {
    // 	localStorage.setItem(
    // 		"currentPatientId",
    // 		this.$store.state["patient"].currentPatientId
    // 	);
    // }

    // //   // // // // // console.log(' GET FROM localST ')
    // //   // // // // // console.log(localStorage.getItem('currentPatientId'))

    // return this.personsTasks;
  } else {
    toastrError("There was a problem getting tasks for this patient");
  }
  return patientStore.currentPatient;
}

function setSecurityGroup() {
  // console.log(">>>>>>>	setSecurityGroup");

  // console.log("  		2 STORE		workListStore.toggleLoadPanel()      >>>>>>>>>>");
  workListStore.toggleLoadPanel();

  // console.log(">>>>>>>	  		2 STORE		this.setPatientChartBool");

  // console.log(">>>>>>>	  		2 STORE		this.setPatientChartBool");
  userStore.setPatientChartBool();

  userStore.changeSecurityGroupToStore(userStore.currentSecurityGroup).then((resp) => {
    // console.log(" resp ");
    // console.dir(resp);

    if (resp.ok) {
      // console.log("ON : this.setPatCHART bool >  ");
      userStore.setPatientChartBool();

      // ! RETEST and REDESIGN iif logic != needed

      // route.path.includes('/Patient')

      // if (this.$router.currentRoute.name === 'Measures') {
      if (route.name === "Measures") {
        // // console.log(' Measures reached !!!    false ')
        // this.$router.go(this.$router.currentRoute)
        // this.$emit('rteName', false)
        emit("rteName", false);
      }
      // else if (this.$router.currentRoute.name === 'Summary') {
      else if (router.name === "Summary") {
        // // console.log(' 		SUMMARY  reached !!!    true ')
        // this.$router.push({ path: '/Summary' })
        // this.$emit('rteName', this.$router.currentRoute.name)
        // this.$emit('rteName', true)
        emit("rteName", true);
        // this.$root.$emit('rteName', true)
        // this.$emit('savePatientToList', patient.personID)
        // this.$root.emit('openPopup')
      } else {
        // this.$router.go({ path: '/LandingPage' })
        // // console.log(' rteName null !!!!!!!!  ')
        // this.$emit('rteName', null)
        emit("rteName", false);
      }

      // console.log("   ROUTE 2 Dashboard");

      // router.push("/Dashboard/Primary");
      router.push("/LandingPage");
    }
  });

  // conso
}

function resetSearch() {
  // console.log("						>>>>>>>	resetSearch");
  searchResults = [];
  searchTerm.value = "";
  showSearchResults.value = false;
}

async function getPatientTasksLOCAL() {
  const response = await getPatientTasks(this.localPersonId);
  if (response.ok) {
    // console.log(					'TASKS filled >' + '  localPersonId = ' + this.localPersonId				)
    // this.tasks = response.payload
    // console.log(this.tasks)

    // console.log(					'		PATIENT STORE  adding New >>>				: 	Store ? SET : this.$store.state[comments].currentPatientTasks'				)

    // console.log('				 BIND : 	rep.payload >   comments.papTasks > this.task ')

    // ! REV A    store = payload
    this.$store.state["patient"].currentPatientTasks = response.payload;
    // // HERE Add getter from STORE
    // todo HERE Add getter from STORE
    this.tasks = this.$store.state["patient"].currentPatientTasks;

    // this.tasks = response.payload
    // this.$store.state['patient'].currentPatientTasks = this.tasks

    // // // // console.log(					'	 CHK		currentPatientTasks > + ',					this.$store.state['patient'].currentPatientTasks				)
    // // // // console.log(					'	patient ***	STORE       currentPatientTasks :  ' +						this.$store.state['patient'].currentPatientTasks.length				)

    // // // // console.log(					' >>>>>>>>>>>		getPatientTasks  	>> RETURns  : this.tasks   QTY: ',					this.tasks.length				)
    // // // // console.dir(this.tasks)

    return this.tasks;
  } else {
    toastrError("There was a problem getting tasks for this patient");
  }
}
async function getPatientCommunicationsLOCAL() {
  //// //// // console.clear()()
  // // // // console.log('  		LOCAL >:  PAT TASKS:		getLocalPatientTasks')
  // // // console.log(' 	 getPatientComms( ) ...   GOING TO  API')
  //const response = await getPatientTasks(this.localPersonId)

  const response = await getPatientCommunications(this.localPersonId);

  // // // console.log(' getPatientCommunications RESPONSE: ')
  // // // console.dir(response)

  if (response.ok) {
    this.commsROOT = response.payload;

    // // // console.log(' getCommunications RESPONSE:  commsROOT')
    // // // console.dir(this.commsROOT)
    // // // // console.dir(this.communications.fields)
    // // // // console.dir(this.communications.records)

    // // // console.log(					'🚀 ----------------------------------------------------------------------------------------- QTY:',					this.commsROOT.records.length				)

    // // // console.log(					'-------------------------------- PATIENT STORE :   SET COMMUNICATIONS [ ] '				)
    this.$store.commit("setCurrentPatientCommunications", this.commsROOT.records);

    // this.setCurrentSelectedPatientCommunication(this.communication.records[0])

    // this.tasks = this.currentPatient.communications
    // // // // console.log('this.currentPatient.communications')
    // // // // console.dir(this.tasks)
    return this.commsROOT.records;
  } else {
    toastrError("There was a problem getting communications for this patient");
  }
}

onBeforeMount(() => {
  // workListStore.getAllMyAlertsStoreToAPI();
  if (workListStore.allMyAlerts?.length > 0) {
    return;
  } else {
    const response1 = workListStore.getAllMyAlertsStoreToAPI();
  }
});

onMounted(() => {
  // console.log("onMounted() :      SEARCH LOGIN  >>>>");
  // console.clear();
  // console.log("patientStore.currentPatient");
  // console.log(patientStore.currentPatient);
  // console.log("secGroups");
  // console.log(secGroups);
  // console.log("securityGroup");
  // console.log(securityGroup);
  // console.log(" SEARCH LOGIN security  page >>>>>>>>");
  // console.log(" showSearchResults : ", showSearchResults.value);
  // console.log(" headerBgVariant : ", headerBgVariant);
  // console.log(" searchTerm : ", searchTerm);
  // console.log("-------------------------------------currentRouteName--------------	this.$router.currentRoute");
  // console.log("currentRouteName.value");
  // console.log(currentRouteName.value);
  // toast.info('ROUTE TEST >>>>>>>>>>>>>>>')
  // console.log("router");
  // console.log(router);
  // console.log("router.currentRoute.value");
  // console.log(router.currentRoute.value);
  // // console.log("route");
  // console.log(route);
  // console.log("+++++++++++++++++++++++++++++++++++++++++++++");
  // console.log("route.name");
  // console.log(route.name);
  // console.log("+++++++++++++++++++++++++++++++++++++++++++++");
  // console.log(router.currentRoute)
  // console.log(router.currentRoute)
  // console.log(router.currentRoute.value)
  // console.log(router.currentRoute.value.path)
});
</script>

<style lang="scss" scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #f2f2f2;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 32px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
  --purple: #6f42c1;
}
.custom-element {
  color: var(--purple);
}
.group-search-login-row {
  // background-color: #eef8ef;
  display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  // align-items: baseline;
  // padding-bottom: 1rem;
  // flex-wrap: wrap;
}

#sidebar-UserDetails {
  background-color: #08e41b !important;
  color: red;
}

.input-group {
  background-color: transparent !important;
  height: 20px;
}

.group-search-login-row {
  display: flex;
  justify-content: space-between;
  // align-items: baseline;
  padding-bottom: 0rem;
  flex-wrap: wrap;
  background: transparent;
  color: transparent;
}

.security-group-select {
  margin-top: 0.5em;
}

.popover {
  max-width: 800px !important;
}

.search-results-wrapper {
  max-height: 250px;
  overflow: auto;
  width: 22vw;
  background: transparent; // #b0c1b2;
  //  color: cyan;
  //  padding: 0px;
}

.search-results-table {
  display: table;
}

.search-results-table__record {
  display: table-row;
  text-decoration: none;
  color: transparent;
  line-height: 22px;

  &:hover {
    background-color: #0a7bfcae;
    color: #c6d9c8;
    cursor: pointer;
  }
}

.search-results-table__cell {
  padding: 0px 0.5rem;
  display: table-cell;

  & > span.label {
    font-weight: 700;
  }
}

.login-info {
  font-weight: 600;
  //	color: $primary-dark-blue;
  // padding-top: 0.5em;
}

.group-label {
  font-weight: 800;
  //	color: $primary-dark-blue;
  padding-right: 0.5em;
}

.popover {
  max-width: 500px;
  background: pink;
}

#search-container {
  background: darkturquoise;
  color: blue;
}
</style>
